// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, object, string } from 'prop-types'

// NOTE - this is a special type of checkbox.
// it behaves as a 'select all' for a given set of aggregate matches.

// input.value is going to be an array which tracks all of the segment end ids that are selected.
// this input's value is also input.value

const AggregateRowCheckbox = ({ aggregateGroupMatches, id, input }) => {
  const checked = input.value.length === aggregateGroupMatches.length

  const handleChange = () => (
    input.onChange(
      checked
        ? []
        : aggregateGroupMatches.map(d => d.segmentEndId)
    )
  )

  return (
    <td>
      <label
        className={'padding-right-half'}
        htmlFor={id}
        id={`${id}-label`}>
        {'Select All '}
      </label>
      <input
        {...input}
        id={id}
        type={'checkbox'}
        checked={checked}
        onBlur={() => null}
        onChange={handleChange} />
    </td>
  )
}

AggregateRowCheckbox.propTypes = {
  aggregateGroupMatches: array.isRequired,
  id: string.isRequired,
  input: object.isRequired,
}

export default AggregateRowCheckbox
